<template>
  <div>
    <div v-if="isLoading" class="custom-loader-sorgente">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1"
        stroke="#000000"
        style="stroke: #000000; height: 20px; width: 20px; animation: spin-custom-sorgente 1s linear infinite !important;"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
        />
      </svg>
    </div>
    <div v-else-if="error">Error loading data: {{ error }}</div>
    <div v-else>
      {{ electrificationData }}
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    productCode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      electrificationData: null,
      error: null,
    };
  },
  watch: {
    productCode: {
      immediate: true,
      handler: "fetchElectrification",
    },
  },
  methods: {
    fetchElectrification() {
      this.isLoading = true;
      this.error = null;
      this.electrificationData = null;

      axios
        .get(
          `https://vistosi.it/api/get-electrification.php?product_code=${this.productCode}`
        )
        .then((response) => {
          this.electrificationData = response.data;
        })
        .catch((error) => {
          this.error = `Error fetching electrification: ${error.message}`;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style>
.custom-loader-sorgente {
  display: flex !important;
  align-items: center !important;
  width: 20px !important;
  height: 20px !important;
}

.custom-svg-sorgente {
  animation: spin-custom-sorgente 1s linear infinite !important;
  width: 20px !important;
  height: 20px !important;
}

@keyframes spin-custom-sorgente {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>